export const getLanguagesDictionary = <
    K extends string,
    D extends K
>(
    keys: readonly K[] | null,
    defaultLang: D,
  ): Record<Exclude<K, D>, string> => {
  if (keys == null) {
    throw new Error("getLanguagesDictionary: 'keys' must not be null");
  }

  return Object.fromEntries(
    keys
      .filter((k) => k !== defaultLang)
      .map((k) => [k, ''] as const),
  ) as Record<Exclude<K, D>, string>;
};
